import React from "react";

const ThankYouPage = () => (
  <div id="thank-you-page" className="quiz-step active">
    <h2>Готово!</h2>
    <p>Ваша заявка вже в роботі, ми незабаром з Вами зв'яжемось.</p>
  </div>
);

export default ThankYouPage;
